module.exports = __webpack_public_path__ + "static/media/MpqCmp.8aa3c6dc.wasm";